<template>
  <Layout>
    <!-- Header -->
    <div class="row">
      <div class="col-10">
        <PageHeader title="Video Incident Detection System Events" />
      </div>
      <div class="col-2">
        <button type="button" :class="isDataFilterActive
          ? 'btn btn-success toggle-vids-filter w-100'
          : 'btn btn-primary toggle-vids-filter w-100'
          " @click="toggleFilter">
          <span v-if="!isDataFilterActive"><i class="bx bx-cog bx-spin toggle-vids-filter"></i> Select Filters
          </span>
          <span v-else><i class="bx bx-check toggle-vids-filter mr-4"></i>Filters
            Applied</span>
        </button>
      </div>
    </div>
    <hr />
    <!-- Statistics -->
    <div class="row">
      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Total Incidents</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalIncidents }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-folder-open"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Wrong Way</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalWrongWay }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-warning font-size-20">
                  <i class="bx bx-x-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Parked Vehicle</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalParkedVehicle }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-no-entry"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Human Crossing</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalHumanCrossing }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-warning font-size-20">
                  <i class="bx bx-walk"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Human Detected</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalHumanDetected }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-user-x"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Deaccelerated</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalDeacceleration }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-warning font-size-20">
                  <i class="bx bxs-car"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Accelerated</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalVehicleAccelerated }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-success font-size-20">
                  <i class="bx bxs-truck"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">Reverse Traffic</p>
                <h5 class="mb-0" v-if="incidentStatistics.vids">
                  {{ incidentStatistics.vids.totalReverseTraffic }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-caret-left-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Incidents Table -->
    <Loader>
      <div class="table-responsive mb-0">
        <b-table class="datatables" :items="allIncidents" :fields="fields" responsive="sm" :per-page="0"
          :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(event_name)="row">
            {{ GetVidsFriendlyEventName(row.item.event_name) }}
          </template>
          <template #cell(report_time)="row">
            {{
              String(row.item.report_time).includes(" ")
              ? row.item.report_time
              : new Date(row.item.report_time).toLocaleString()
            }}
          </template>
          <template #cell(type)="row">
            <span v-if="row.item.type">
              {{ GetVidsFriendlyTypeName(row.item.type) }}</span>
            <span v-else>No Type</span>
          </template>
          <template #cell(challan_status)="row">
            <span v-if="row.item.challan_status === 'generated'" class="badge bg-success">
              SENT TO NIC
            </span>
            <span class="badge bg-danger" v-else>NOT GENERATED</span>
          </template>
          <template #cell(image_url)="row">
            <img v-if="!String(row.item.image_url).includes('undefined')"
              :src="`${config.CLIENT_URL}${row.item.image_url}`" width="80"
              @click="showImage(`${config.CLIENT_URL}${row.item.image_url}`)" style="cursor: pointer" />
            <span v-else>No Image</span>
          </template>
          <template #cell(actions)="row">
            <b-button v-if="row.item.type" size="sm" variant="danger" class="m-1" @click="showChallanDetails(row.item)"
              :disabled="row.item.challan_status === 'generated'">
              Raise Challan
            </b-button>
            <b-button v-if="row.item.type" size="sm" variant="primary" class="m-1" @click="showVidsDetails(row.item)">
              View Details
            </b-button>
            <button v-if="!row.item.is_converted" @click="openConvertToIncident(row.item)"
              class="btn btn-sm btn-primary m-1">
              Assign to RPO <i class="fa fa-arrow-right ms-1"></i>
            </button>
            <button v-else class="btn btn-sm btn-success m-1"
              @click="$router.push(`/incident/view-incident-details/${row.item.conversion_id}`)">
              Track Incident <i class="fa fa-arrow-right ms-1"></i>
            </button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </Loader>

    <!-- Incident details modal -->
    <b-modal id="more-details-modal" size="lg" title-class="font-18" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Event Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger m-2" @click="$bvModal.hide('more-details-modal')">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </template>

      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">VIDS ID</th>
                      <td>{{ selectedIncident.id }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Event Name</th>
                      <td>
                        {{
                          String(selectedIncident.event_name).replace(/_/g, " ")
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Class</th>
                      <td>
                        {{ selectedIncident.type }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Zone ID</th>
                      <td>
                        {{ selectedIncident.zone_id }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Camera ID</th>
                      <td>
                        {{ selectedIncident.camera_id }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Camera Name</th>
                      <td>
                        {{ selectedIncident.camera_name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <th scope="row">Alert Time</th>
                      <td>
                        {{ getReadableDateTime(selectedIncident.alert_time) }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Exact Report Time</th>
                      <td>
                        {{ getReadableDateTime(selectedIncident.report_time) }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Device IP</th>
                      <td>{{ selectedIncident.device_ip }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Exact IP</th>
                      <td>{{ selectedIncident.exact_ip }}</td>
                    </tr>
                    <tr>
                      <th scope="row">Severity</th>
                      <td>{{ selectedIncident.severity }}</td>
                    </tr>
                    <tr>
                      <th scope="row">RPO Assigned</th>
                      <td>{{ selectedIncident.is_converted ? 'Yes' : 'No' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Images</h4>
              <img v-for="(src, index) in incidentImages" :key="index" class="float-left image"
                @click="() => showCaptiomImg(index)" width="150" :src="src" />
            </div>
            <vue-easy-lightbox :visible="visibleCaption" :imgs="incidentImages" :index="index"
              @hide="handleCaptionHide"></vue-easy-lightbox>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- convert details modal -->
    <b-modal id="convert-incident-modal" size="lg" title-class="font-18" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Assign Event to RPO</h5>
        </div>
        <div>
          <button type="button" class="btn btn-sm btn-outline-danger" @click="closeAssignModal">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </template>

      <form @submit.prevent="convertToIncident">
        <div class="row">
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Event Name</th>
                        <td>
                          <h6>{{ GetVidsFriendlyEventName(selectedIncident.event_name) }}</h6>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">VIDS ID</th>
                        <td>
                          <input class="form-control inp-bg" v-model="selectedIncident.id" disabled />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Vehicle Number</th>
                        <td>
                          <input class="form-control inp-bg" placeholder="Enter vehicle number"
                            v-model="convertToIncidentData.vehicleNo" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Chainage No.</th>
                        <td>
                          <input class="form-control inp-bg" placeholder="Enter chainage number"
                            v-model="convertToIncidentData.chainageNo" required />
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Description</th>
                        <textarea class="form-control inp-bg" rows="5" v-model="convertToIncidentData.description"
                          required></textarea>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <th scope="row">Event Location</th>
                        <td>
                          <h6>{{ selectedIncident.camera_name }}</h6>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Select category</th>
                        <td>
                          <v-select class="style-chooser" v-model="convertToIncidentData.sub_category_id"
                            :options="options.subCategory" label="sub_category_name" :reduce="(vc) => vc.id"
                            required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Vehicle Class</th>
                        <td>
                          <v-select class="style-chooser" v-model="convertToIncidentData.vehicle_class_id"
                            :options="options.vehicleClass" label="class_name" :reduce="(vc) => vc.id"
                            required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Assigned To</th>
                        <td>
                          <v-select class="style-chooser" v-model="convertToIncidentData.reported_to_id"
                            :options="options.informedTo" label="firstName" :reduce="(vc) => vc.userId"
                            required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Side</th>
                        <td>
                          <v-select class="style-chooser" v-model="convertToIncidentData.side" :options="options.side"
                            label="name" :reduce="(vc) => vc.name" required></v-select>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Alert Time</th>
                        <td>
                          {{ getReadableDateTime(selectedIncident.alert_time) }}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Exact Report Time</th>
                        <td>
                          {{ getReadableDateTime(selectedIncident.report_time) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">VIDS Photos</h4>
                <img v-for="(src, index) in incidentImages" :key="index" class="float-left image"
                  @click="() => showCaptiomImg(index)" width="150" :src="src" />
              </div>
              <vue-easy-lightbox :visible="visibleCaption" :imgs="incidentImages" :index="index"
                @hide="handleCaptionHide"></vue-easy-lightbox>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="text-center">
              <button type="submit" class="btn btn-primary mb-2 m-2">
                <i class="mdi mdi-content-save-all me-1"></i> Convert to Incident & Assign to RPO <i
                  class="fa fa-arrow-right ms-1"></i>
              </button>
            </div>
          </div>
        </div>

      </form>
    </b-modal>

    <!-- Raise challan modal -->
    <b-modal id="raise-challan-modal" title="Raise Challan" title-class="font-18" size="xl" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Challan Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('raise-challan-modal')">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </template>

      <ChallanForm :incidentDetails="selectedIncident" @close="$bvModal.hide('raise-challan-modal')" />
    </b-modal>

    <!-- Quick image preview -->
    <vue-easy-lightbox :visible="showSingleImage" :imgs="selectedImage" :index="index"
      @hide="handleCaptionHide"></vue-easy-lightbox>

    <!-- Filters -->
    <VidsFilter @close="toggleFilter" :packageFilterOptions="packageFilterOptions"
      :typesFilterOptions="typesFilterOptions" :categoryFilterOptions="categoryFilterOptions"
      @getFilteredIncidents="getFilteredIncidents" @resetFilter="resetFilter" />
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import config from "@/constants/config";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import RaiseNewIncident from "./raise-incident.vue";
import DatePicker from "vue2-datepicker";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import rpoMap from "../../views/incident/rpoVehicleMap.vue";
import incidentMixin from "../../mixins/incident";
import "../../assets/plugins/range-slider/vue-range-slider.css";
import VueRangeSlider from "../../assets/plugins/range-slider/vue-range-slider";
import Loader from "../../components/widgets/loader.vue";
import VidsFilter from "@/components/incidents/vids-filter";
import ChallanForm from '@/components/incidents/challan-form'

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],

  components: {
    Layout,
    PageHeader,
    RaiseNewIncident,
    VueEasyLightbox,
    rpoMap,
    DatePicker,
    VueRangeSlider,
    Loader,
    VidsFilter,
    ChallanForm
  },

  data () {
    return {
      config: config,
      selectedImage: null,
      showSingleImage: false,
      isDataFilterActive: false,
      datepickervalueFrom: null,
      datepickervalueTo: null,
      incidentType: null,
      packageFilter: null,
      categoryFilterOptions: [],
      typesFilterOptions: [],
      packageFilterOptions: [],
      incidentCategory: null,
      allIncidents: [],
      visibleCaption: false,
      selectedIncident: {},
      index: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      operatorId: null,

      convertToIncidentData: {
        sub_category_id: '',
        description: '',
        chainageNo: '',
        side: '',
        vehicleNo: '',
        vehicle_class_id: '',
        reported_to_id: '',
      },

      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "plate_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "event_name",
          label: "Event Name",
          sortable: false,
        },
        {
          key: "location",
          label: "Location",
          sortable: true,
        },
        {
          key: "report_time",
          label: "Report Time",
          sortable: false,
        },
        // {
        //   key: "severity",
        //   label: "Severity",
        //   sortable: false,
        // },
        {
          key: "type",
          label: "Type",
          sortable: false,
        },
        {
          key: "challan_status",
          label: "Challan Status",
          sortable: false,
        },
        {
          key: "image_url",
          label: "Image",
          sortable: false,
        },
        {
          key: "actions",
          sortable: false,
          label: "Action",
        },
      ],

      options: {
        subCategory: [],
        incidentSource: [],
        side: [{ name: "LHS" }, { name: "RHS" }],
        informedTo: [],
        vehicleClass: [],
      },

      socketInterval: null,
    };
  },

  created () {
    this.socketInterval = setInterval(() => {
      this.$socket.emit("REQUEST:VIDS_INCIDENTS_STATS");

      if (!this.isDataFilterActive) {
        if (this.currentPage == 1) {
          this.$socket.emit("REQUEST:VIDS_INCIDENTS");
        }
      }
    }, 5000);

    this.$socket.emit("REQUEST:VIDS_INCIDENTS_STATS");
    this.$socket.emit("REQUEST:VIDS_INCIDENTS");
  },

  async mounted () {
    this.operatorId = this.currentUser.user.id;
    await this.getIncidentMasters();

    this.sockets.subscribe("GET_FILTERED_VIDS_INCIDENTS", (data) => {
      this.allIncidents = data;
    });

    const filtersData = await this.GetVidsFiltersData();

    // Categories filter
    for (let category of filtersData.categories) {
      if (category) this.categoryFilterOptions.push({ category });
    }

    // Types filter
    for (let type of filtersData.types) {
      if (type) this.typesFilterOptions.push({ type });
    }

    // Locations Filter
    for (let pkg of filtersData.locations) {
      if (pkg) this.packageFilterOptions.push({ location: pkg });
    }

    this.$store.dispatch("layout/changeLoaderValue", false);
  },

  computed: {
    incidents () {
      return this.$store.getters["socket/incident"].vidsIncidents;
    },
    incidentStatistics () {
      return this.$store.getters["socket/incident"].statistics;
    },
    incidentImages () {
      return this.selectedIncident.image_url
        ? [this.selectedIncident.image_url]
        : [];
    },
    currentUser () {
      return this.$store.getters["auth/user"];
    },
  },

  watch: {
    currentPage: async function () {
      await this.getAllIncidents();
    },
    incidents: async function () {
      this.allIncidents = this.incidents.data;
      this.perPage = this.incidents.rows;
      this.totalRows = this.incidents.totalPageNumber;
    },
  },

  methods: {

    showChallanDetails (incident) {
      if (incident.category_name !== "Accident") {
        this.selectedIncident = { ...incident, eventType: 'vids' };
        this.$bvModal.show("raise-challan-modal");
      }
    },
    closeAssignModal () {
      this.$bvModal.hide('convert-incident-modal')
      this.convertToIncidentData.class_name = ''
      this.convertToIncidentData.description = ''
    },
    async getIncidentMasters () {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.vehicleClass = incidents.getVehicleClass;
        this.options.offenceId = incidents.getOffenceId;
        this.options.districtCode = incidents.getDistrictCode;
        this.options.stateCode = incidents.getStateCode;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.informedTo = incidents.rpoData;
        this.options.accidentLevel = incidents.getAccidentLevel;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    toggleFilter () {
      document.body.classList.toggle("vids-right-bar-enabled");
    },

    resetFilter () {
      this.isDataFilterActive = false;
      this.datepickervalueFrom = null;
      this.datepickervalueTo = null;
      this.isDataFilterActive = false;
      this.incidentType = null;
      this.packageFilter = null;
      this.incidentCategory = null;
      this.toggleFilter();
    },

    showImage (imageUrl) {
      this.selectedImage = [imageUrl];
      this.showSingleImage = true;
    },

    showVidsDetails (incident) {
      this.selectedIncident = incident;
      this.$bvModal.show("more-details-modal");
    },

    openConvertToIncident (incident) {
      this.selectedIncident = incident;
      this.convertToIncidentData.vehicle_class_id = this.options.vehicleClass.find(v => v.class_name == this.selectedIncident.type).id
      this.convertToIncidentData.description = 'VIDS EVENT: ' + this.GetVidsFriendlyEventName(this.selectedIncident.event_name)
      this.$bvModal.show("convert-incident-modal");
    },

    async convertToIncident () {
      try {

        const body = {
          ...this.convertToIncidentData,
          parent_id: this.selectedIncident.id,
          source_id: 7,
          incident_datetime: this.selectedIncident.alert_time,
          reported_datetime: this.selectedIncident.report_time,
          status: "Open",
          reported_by_id: this.$store.getters["auth/user"].user.id,
        };

        if (body.sub_category_id === '' || body.description === '' || body.chainageNo === '' ||
          body.side === '' || body.vehicleNo === '' || body.vehicle_class_id === '' || body.reported_to_id === '') {
          Swal.fire({
            title: "Missing Data!",
            text: `Please complete all the fields before assigning to RPO`,
            icon: "warning",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 3000
          })
          return
        }

        const rpo = this.options.informedTo.find((u) => u.userId == body.reported_to_id)

        Swal.fire({
          title: "Are you sure?",
          text: `The event will be assigned to ${rpo.firstName}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {

          await this.ConvertVidsToIncident(body);
          this.$bvModal.hide("convert-incident-modal");

          if (result.isConfirmed) {
            Swal.fire(
              "VIDS Event Converted!",
              "The event has been assigned to the RPO",
              "success"
            );
          }
        });
      } catch (error) {
        Swal.fire({
          title: "Failed to Assign RPO",
          text: (error.response) ? error.response.data.message : error,
          icon: "warning",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000
        })
      }
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    showCaptiomImg (index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide () {
      this.visibleCaption = false;
      this.showSingleImage = false;
    },

    showResolveIncidentModal (item) {
      if (item) this.selectedIncident = item;
      this.$bvModal.show("mark-resolve-modal");
    },

    async getAllIncidents () {
      let fromDate = new Date(this.datepickervalueFrom);
      let toDate = new Date(this.datepickervalueTo);

      const result = await this.GetAllVidsIncidents({
        page: this.currentPage,
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
        incidentType: this.incidentType,
        packageFilter: this.packageFilter,
        category: this.incidentCategory,
      });

      this.perPage = result.rows;
      this.totalRows = result.totalPageNumber;
      this.allIncidents = result.data;
    },

    async getFilteredIncidents (e) {
      const data = JSON.parse(e);
      this.datepickervalueFrom = data.datepickervalueFrom;
      this.datepickervalueTo = data.datepickervalueTo;
      this.isDataFilterActive = false;
      this.incidentType = data.incidentType;
      this.packageFilter = data.packageFilter;
      this.incidentCategory = data.incidentCategory;

      let fromDate = new Date(this.datepickervalueFrom);
      let toDate = new Date(this.datepickervalueTo);

      if (
        fromDate.toISOString().includes("1970-01-01") &&
        toDate.toISOString().includes("1970-01-01") &&
        !this.incidentType &&
        !this.incidentCategory &&
        !this.packageFilter
      ) {
        Swal.fire("Please select filter options", "", "warning");
        return;
      }

      toDate.setHours(23, 59, 59, 999);

      this.isDataFilterActive = true;
      this.$store.dispatch("layout/changeLoaderValue", true);

      this.toggleFilter();

      const result = await this.GetAllVidsIncidents({
        page: this.currentPage,
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
        incidentType: this.incidentType,
        packageFilter: this.packageFilter,
        category: this.incidentCategory,
      });

      this.perPage = result.rows;
      this.totalRows = result.totalPageNumber;
      this.allIncidents = result.data;
      this.$store.dispatch("layout/changeLoaderValue", false);
    },
  },

  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },
};
</script>

<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
